import { CircularProgress, Typography } from '@mui/material'
import React from 'react'
import { allColors } from '../../themes/Colors'
import { Strings } from '../../utils/Strings'
import { checkNull } from '../../utils/Helpers'
import useStyles from './Styles'

const PaymentStatus = (props) => {
  const styles = useStyles()
  const { payStatus = false, msg = '' } = props?.data
  const isSuccess = payStatus === Strings.success
  const isLoading = payStatus === Strings.loading
  return (
    <div className={styles.container}>
      <div className={styles.sub_container}>
        {isLoading ? (
          <>
            <CircularProgress
              sx={{
                mb: 3,
              }}
              color='primary'
              style={{
                fontSize: '100px !important',
                color: allColors.primaryColor,
              }}
            />
            <Typography
              fontWeight={600}
              sx={{
                mb: 1,
                fontSize: '24px',
              }}
            >
              Processing Payment
            </Typography>
            <Typography
              color='#4b4b4b !important'
              fontSize={'20px'}
              textAlign='center'
            >
              Please be patient. this process might take some time, please do
              not hit refresh or browser back button or close this window
            </Typography>
          </>
        ) : (
          <>
            <img
              src={
                isSuccess
                  ? 'https://aautimpwebdev.blob.core.windows.net/logo/success.png'
                  : 'https://aautimpwebdev.blob.core.windows.net/logo/fail.png'
              }
              alt='icon'
              height={100}
              style={{
                marginBottom: '6px',
                color: allColors.primaryColor,
              }}
            />
            <Typography
              fontWeight={600}
              sx={{
                mb: 1,
                fontSize: '24px',
              }}
            >
              {isSuccess ? `Payment Successful!` : `Payment Failed !`}
            </Typography>
            <Typography color='#4b4b4b !important' fontSize={'20px'}>
              {checkNull(msg) ? Strings.authFail : msg}
            </Typography>
          </>
        )}
      </div>
    </div>
  )
}

export default PaymentStatus
